import { render, staticRenderFns } from "./AdditionalMealsShiftTabs.vue?vue&type=template&id=282bca5c&scoped=true"
import script from "./AdditionalMealsShiftTabs.vue?vue&type=script&lang=js"
export * from "./AdditionalMealsShiftTabs.vue?vue&type=script&lang=js"
import style0 from "./AdditionalMealsShiftTabs.vue?vue&type=style&index=0&id=282bca5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282bca5c",
  null
  
)

export default component.exports